import firebase from "firebase/app";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";

type ScrollToSectionArgs = {
  anchor: string;
  analyticsEnum: AnalyticsEventEnum;
  offset?: number;
};
export const scrollToSection = (args: ScrollToSectionArgs) => {
  const { anchor, analyticsEnum, offset = 0 } = args;
  const target = document.querySelector(anchor);
  const body = document.querySelector("body");

  if (window.scrollTo) {
    firebase.analytics().logEvent(analyticsEnum);
    const targetTop = target.getBoundingClientRect().y;
    const bodyTop = body.getBoundingClientRect().y;

    const targetPositionRelativeToViewport = targetTop - bodyTop - offset;
    window.scrollTo({
      behavior: "smooth",
      top: targetPositionRelativeToViewport,
    });
  }
};
